var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{ref:"audioElement",attrs:{"id":"sound_beep"}},[_c('source',{attrs:{"src":_vm.mp3Source,"type":"audio/mpeg"}}),_vm._v(" Your browser does not support the audio element. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }